/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getOvrsTransactions = (
  payload = { module_type: 'OVRS' },
  callback
) =>
  req.list(
    c.GET_OVR_TRANSACTIONS,
    'api/v1/administrators/transaction_histories/',
    payload,
    callback
  );

export const validateTicket = (payload, callback) =>
  req.list(
    c.VALIDATE_OVR_TRANSACTION,
    'api/v1/administrators/traffic_violators/',
    payload,
    callback
  );

export const showTransaction = (id, payload, callback) =>
  req.item(
    c.SHOW_OVR,
    `api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback
  );

export const startAssessment = (id, callback) =>
  req.update(
    c.START_ASSESSMENT,
    `api/v1/administrators/transaction_histories/${id}/start_assessment`,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const approveTicket = (id, payload, callback) =>
  req.update(
    c.APPROVE_TICKET,
    `api/v1/administrators/transaction_histories/ovr/${id}/approve`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const discount = (id, payload, callback) =>
  req.update(
    c.APPROVE_TICKET,
    `api/v1/administrators/transaction_histories/ovr/${id}/discount`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const rejectTicket = (id, payload, callback) =>
  req.update(
    c.REJECT_TICKET,
    `api/v1/administrators/transaction_histories/ovr/${id}/reject`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const tagAsReceived = (id, payload, callback) =>
  req.update(
    c.TAG_AS_RECEIVE,
    `api/v1/administrators/transaction_histories/ovr/${id}/tag_as_received`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const createUserManagement = (payload, callback) =>
  req.create(
    c.CREATE_USER_MANAGEMENT,
    'api/v1/administrators/ordinance_violation_receipts',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateUserManagement = (id, payload, callback) =>
  req.update(
    c.UPDATE_USER_MANAGEMENT,
    `api/v1/administrators/ordinance_violation_receipts/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeUserManagement = (id, payload, callback) =>
  req.remove(
    c.REMOVE_USER_MANAGEMENT,
    `api/v1/administrators/ordinance_violation_receipts/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Remove !');
      if (callback) callback();
    }
  );

export const assessReceipt = (id, payload, callback) =>
  req.update(
    c.ASSESS_RECEIPT,
    `/api/v1/administrators/transaction_histories/${id}/assess_payment_receipt`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const tagAsPrintedTransaction = (id, payload, callback) =>
  req.update(
    c.TAG_AS_PRINTED_TRANSACTION,
    `api/v1/administrators/transaction_histories/ovr/${id}/tag_as_printed`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const applyPenalty = (id, payload, callback) =>
  req.update(
    c.APPLY_PENALTY,
    `api/v1/administrators/transaction_histories/ovr/${id}/penalty`,
    payload,
    callback
  );

export const checkOr = (payload, callback) =>
  req.list(
    c.OR_CHECK,
    `api/v1/administrators/transaction_histories/ovr/check_or`,
    payload,
    callback
  );

export const generateSOA = (id, payload, callback) =>
  req.create(
    c.GENERATE_SOA,
    `api/v1/administrators/transaction_histories/ovr/${id}/generate_soa`,
    payload,
    callback
  );

export const approveSOA = (id, payload, callback) =>
  req.update(
    c.APPROVE_SOA,
    `api/v1/administrators/transaction_histories/ovr/${id}/approve_soa`,
    payload,
    callback
  );

export const regenerateSOA = (id, payload, callback) =>
  req.create(
    c.REGENERATE_SOA,
    `api/v1/administrators/transaction_histories/ovr/${id}/regenerate_soa`,
    payload,
    callback
  );

export const cancelSoa = (id, remarks, payload, callback) =>
  req.update(
    c.CANCEL_SOA,
    `api/v1/administrators/transaction_histories/ovr/${id}/cancel_soa?remarks=${remarks}`,
    payload,
    callback
  );

export const cancelApplication = (id, remarks, payload, callback) =>
  req.update(
    c.CANCEL_APPLICATION,
    `api/v1/administrators/transaction_histories/ovr/${id}/cancel_application?remarks=${remarks}`,
    payload,
    callback
  );
